import createApiInstance from '../../utils/createApiInstance';
import { PROFILES_URL } from '../../constants/URLs';
import { AxiosResponse } from 'axios';
import { ProfileListInfo } from '../../../types/profiles/ProfileListInfo';

const profilesServiceInstance = createApiInstance(PROFILES_URL);

export class ProfilesService {
    private constructor() {}

    static async getProfiles(): Promise<ProfileListInfo> {
        const response: AxiosResponse = await profilesServiceInstance.get('');

        return response.data;
    }
}
